function toggleVisibility(element, isVisible) {
  element.style.visibility = isVisible ? "visible" : "hidden";
  element.style.opacity = isVisible ? "1" : "0";
}

function setLangFooterLinks(langList) {
  const zhEl = langList.querySelector('[lang="zh-TW"]');
  const enEl = langList.querySelector('[lang="en"]');

  const pathname = window.location.pathname.replace(/^\/en/, ""); // 移除 /en
  const fullPath = pathname + (window.location.search || ""); // 組合查詢參數

  if (zhEl) zhEl.setAttribute("href", fullPath);
  if (enEl) enEl.setAttribute("href", `/en${fullPath}`);
}

function setHeaderLangLinks() {
  const inputFields = document.getElementsByName("return_to");
  if (inputFields) {
    inputFields.forEach((inputFeild) => {
      inputFeild.value = window.location.pathname + window.location.search;
    });
  }
}

function fixLangToggle(langHeading) {
  // console.log(langHeading);
  if (!langHeading) return;

  langHeading.addEventListener("click", (e) => {
    // console.log("click");
    const langList = langHeading.nextElementSibling;
    if (!langList) return;

    if (langHeading.getAttribute("aria-controls") === "lang-list-footer") {
      setLangFooterLinks(langList);
      const isExpanded = langHeading.getAttribute("aria-expanded") === "true";
      toggleVisibility(langList, !isExpanded);
      langHeading.setAttribute("aria-expanded", !isExpanded);
    } else {
      setHeaderLangLinks();
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const langHeadingAnnbar =
    document.querySelector('[aria-controls="lang-list-annbar"]') || "";
  const langHeadingAnnbarMobileNav =
    document.querySelector('[aria-controls="lang-list-annbarMobileNav"]') || "";
  const langHeadingFooter =
    document.querySelector('[aria-controls="lang-list-footer"]') || "";

  fixLangToggle(langHeadingAnnbar);
  fixLangToggle(langHeadingFooter);
  fixLangToggle(langHeadingAnnbarMobileNav);

  if (!langHeadingAnnbarMobileNav) {
    setTimeout(() => {
      const langHeadingAnnbarMobileNav =
        document.querySelector('[aria-controls="lang-list-annbarMobileNav"]') ||
        "";
      fixLangToggle(langHeadingAnnbarMobileNav);
    }, 1000);
  }
});
